// Client-side feature flags for shipping code dark.

// Manufacturer data requests (portal, dashboard, wizard flag strips).
// Launched 2026-09-03 for Supplier/Enterprise orgs. Distributors never see it
// (the account-type check lives at each call site, alongside this flag) and the
// server keeps its own account-type + plan gates. Sending is Pro+ via the
// `can_request_manufacturer_data` entitlement; Free/Starter/Team suppliers see
// the UI and get an upgrade prompt.
export const MANUFACTURER_REQUESTS_LAUNCHED = true;
